// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wqLa","rootParamsCollapsed":"styles_rootParamsCollapsed__10LgZ","rootPreviewFull":"styles_rootPreviewFull__28oul","loader":"styles_loader__24EpW"};